// @flow

import React from 'react';
import { Flex } from 'clark-styles';

import Close from 'assets/icons/close.svg';
import Settings from 'assets/icons/settings.svg';
import { MenuItemLink, RightMargin, SettingsCtaWrapper } from './styles';

type PropsType = { isOpen?: boolean, withCloseIcon?: boolean, onClick(): void };

export const SettingsCta = ({ isOpen = false, withCloseIcon = false, onClick }: PropsType) => (
  <SettingsCtaWrapper isOpen={isOpen}>
    <MenuItemLink as="button" onClick={onClick}>
      <Flex alignItems="center" justifyContent="flex-end">
        <RightMargin>
          <Settings />
        </RightMargin>
        {withCloseIcon ? (
          <>
            <RightMargin>Settings</RightMargin>
            <Close />
          </>
        ) : (
          'Settings'
        )}
      </Flex>
    </MenuItemLink>
  </SettingsCtaWrapper>
);

export default SettingsCta;



// WEBPACK FOOTER //
// ./src/containers/settings-dropdown/settings-cta.js